import { BrowserModule } from '@angular/platform-browser';

import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppComponent } from './app.component';
import { MenuComponent } from './pages/menu/menu.component';
import { MenuItemComponent } from './pages/menu/components/menu-item/menu-item.component';
import { MenuItemModalComponent } from './pages/menu/components/menu-item-modal/menu-item-modal.component';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { OptionalFieldTranslatePipe } from './pipes/app-translate.pipe';
import { LangPickerComponent } from './components/lang-picker/lang-picker.component';
import { ReservationsComponent } from './pages/reservations/reservations.component';
import { inject, NgModule, provideAppInitializer } from '@angular/core';
import { provideRouter, RouterLink, RouterLinkActive, RouterOutlet, Routes, withComponentInputBinding, withViewTransitions } from '@angular/router';
import { MatTimepickerModule } from '@angular/material/timepicker';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { InputNumberModule } from 'primeng/inputnumber';
import { FormsModule } from '@angular/forms';
import { DatePickerModule } from 'primeng/datepicker';

// Angular Material Modules
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { DatePickerComponent } from './components/date-picker/date-picker.component';
import { TimePickerComponent } from "./components/time-picker/time-picker.component";
import { NumPickerComponent } from "./components/num-picker/num-picker.component";
import { StepperModule } from 'primeng/stepper';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { StandaloneSharedModule } from './components/standalone-shared-module';
import { NavbarComponent } from './pages/layout/navbar/navbar.component';
import { HeroComponent } from './pages/hero/hero.component';
import { FooterComponent } from "./pages/layout/footer/footer.component";
import { featureToggleGuard } from './core/guards/feature-toggle.guard';
import { ContentWrapperComponent } from './pages/layout/content-wrapper/content-wrapper.component';
import { ContactComponent } from './pages/contact/contact.component';
import { ProgressiveImageComponent } from './components/progressive-image/progressive-image.component';
import { LanguageService } from './core/services/language.service';

const appRoutes: Routes = [
  { path: '', component: HeroComponent, pathMatch: 'full' },
  { path: 'menu', component: MenuComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'reservations', canActivate: [ featureToggleGuard ], component: ReservationsComponent },
  { path: '**', redirectTo: () => '' }
]

@NgModule({
  declarations: [
    AppComponent,
    MenuComponent,
    MenuItemComponent,
    MenuItemModalComponent,
    ProgressiveImageComponent,
    NavbarComponent,
    LangPickerComponent,
    ReservationsComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    StandaloneSharedModule,
    BrowserModule,
    FormsModule,
    MatTimepickerModule,
    InputGroupModule,
    InputGroupAddonModule,
    InputNumberModule,
    InputTextModule,
    SelectModule,
    DatePickerModule,
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    MatInputModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatIconModule,
    MatCardModule,
    DatePickerComponent,
    TimePickerComponent,
    NumPickerComponent,
    StepperModule,
    BreadcrumbComponent,
    OptionalFieldTranslatePipe,
    FooterComponent,
    ContentWrapperComponent,
    ContactComponent
],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(appRoutes, withComponentInputBinding(), withViewTransitions()),
    providePrimeNG({
      theme: {
        preset: Aura
      }
    }),
    provideTranslateService({
      loader: provideTranslateHttpLoader({prefix:"./assets/i18n/", suffix:".json"}),
      fallbackLang: 'pt',
    }),
    provideAnimationsAsync(),
    provideAppInitializer(() => {
      return inject(LanguageService).init();
    })
  ]
})
export class AppModule { }
